var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "vs-row",
        {
          staticClass: "p-3 mt-2 shadow-sm bg-white",
          class: { selected: _vm.file.febosId === _vm.selectedFile }
        },
        [
          _c(
            "vs-col",
            { attrs: { "vs-lg": "11" } },
            [
              _c(
                "vs-row",
                [
                  _c(
                    "vs-col",
                    {
                      staticClass: "text-center text-primary",
                      attrs: { "vs-lg": "2" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "cursor-pointer",
                          class: { "text-success": _vm.wasCopied },
                          attrs: { "data-cy": "file-number" },
                          on: {
                            click: function($event) {
                              return _vm.copyToClipboard(
                                _vm.file.febosId,
                                _vm.file.numero
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.file.numero.includes("-")
                                  ? _vm.file.numero.substring(
                                      0,
                                      _vm.file.numero.lastIndexOf("-")
                                    )
                                  : _vm.file.numero
                              )
                          ),
                          _c("br"),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.file.numero.includes("-")
                                  ? _vm.file.numero.split("-").pop()
                                  : ""
                              ) +
                              " "
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "vs-col",
                    { attrs: { "vs-lg": "2", "data-cy": "file-status" } },
                    [
                      _vm.file.estado === 1
                        ? _c(
                            "vs-chip",
                            { attrs: { title: "creado" } },
                            [
                              _c("vs-avatar", {
                                attrs: {
                                  icon: "mail_outline",
                                  color: "#43C3B9"
                                }
                              }),
                              _vm._v(" Creado ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.file.estado === 2
                        ? _c(
                            "vs-chip",
                            { attrs: { title: "ingresado" } },
                            [
                              _c("vs-avatar", {
                                attrs: { icon: "check", color: "#ff9f43" }
                              }),
                              _vm._v(" Ingresado ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.file.estado === 3
                        ? _c(
                            "vs-chip",
                            { attrs: { title: "Borrador" } },
                            [
                              _c("vs-avatar", {
                                attrs: {
                                  icon: "query_builder",
                                  color: "#87579e"
                                }
                              }),
                              _vm._v(" Borrador ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.file.estado === 101
                        ? _c(
                            "vs-chip",
                            { attrs: { title: "Descartado" } },
                            [
                              _c("vs-avatar", {
                                attrs: { icon: "delete", color: "gray" }
                              }),
                              _vm._v(" Descartado ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticStyle: { cursor: "pointer" },
                          on: { click: _vm.getFlowDetails }
                        },
                        [
                          _vm.file.estado === 6
                            ? _c(
                                "vs-chip",
                                { attrs: { title: "En flujo" } },
                                [
                                  _c("vs-avatar", {
                                    attrs: {
                                      icon: "query_builder",
                                      color: "#ffc107"
                                    }
                                  }),
                                  _vm._v(" En flujo ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.file.estado === 8 || _vm.file.estado === "8"
                        ? _c(
                            "vs-chip",
                            { attrs: { title: "Anulado" } },
                            [
                              _c("vs-avatar", {
                                attrs: {
                                  icon: "do_not_disturb",
                                  color: "#DB1D2A"
                                }
                              }),
                              _vm._v(" Anulado ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.file.estado === 10
                        ? _c(
                            "vs-chip",
                            { attrs: { title: "Tramitado" } },
                            [
                              _c("vs-avatar", {
                                attrs: { icon: "gavel", color: "#03a9f4" }
                              }),
                              _vm._v(" Tramitado ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.file.estado === 15
                        ? _c(
                            "vs-chip",
                            { attrs: { title: "Numerado" } },
                            [
                              _c("vs-avatar", {
                                attrs: { icon: "gavel", color: "#3f51b5" }
                              }),
                              _vm._v(" Numerado ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.file.estado === 5
                        ? _c(
                            "vs-chip",
                            { attrs: { title: "Rechazado" } },
                            [
                              _c("vs-avatar", {
                                attrs: { icon: "thumb_down", color: "#CE4B4B" }
                              }),
                              _vm._v(" Rechazado ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.file.estado === 12
                        ? _c(
                            "vs-chip",
                            { attrs: { title: "Aprobado" } },
                            [
                              _c("vs-avatar", {
                                attrs: { icon: "thumb_up", color: "#26bd6a" }
                              }),
                              _vm._v(" Aprobado ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.file.estado === 9 || _vm.file.estado === "9"
                        ? _c(
                            "vs-chip",
                            { attrs: { title: "Finalizado" } },
                            [
                              _c("vs-avatar", {
                                attrs: {
                                  icon: "move_to_inbox",
                                  color: "#A04E4E"
                                }
                              }),
                              _vm._v(" Finalizado ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.file.estado === 70 || _vm.file.estado === "70"
                        ? _c(
                            "vs-chip",
                            { attrs: { title: "En contraloría" } },
                            [
                              _c("vs-avatar", {
                                attrs: {
                                  icon: "track_changes",
                                  color: "#3f51b5"
                                }
                              }),
                              _vm._v(" Contraloría ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.file.estado === 100 || _vm.file.estado === "100"
                        ? _c(
                            "vs-chip",
                            { attrs: { title: "Archivado" } },
                            [
                              _c("vs-avatar", {
                                attrs: {
                                  icon: "move_to_inbox",
                                  color: "#607d8b"
                                }
                              }),
                              _vm._v(" Archivado ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "vs-col",
                    { attrs: { "vs-lg": "8" } },
                    [
                      _c(
                        "vs-row",
                        [
                          _c(
                            "vs-col",
                            {
                              attrs: {
                                "vs-lg": "3",
                                "vs-sm": "3",
                                "vs-xs": "12"
                              }
                            },
                            [
                              !_vm.isUseExternalForm
                                ? _c(
                                    "b",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Remitente",
                                          expression: "'Remitente'"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm.file.compradorArea
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isUseExternalForm && _vm.isIntOrExtEXP
                                ? _c(
                                    "b",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Remitente",
                                          expression: "'Remitente'"
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("capitalize")(
                                              _vm.isSenderType
                                                ? _vm.file.compradorCodigo
                                                : _vm.file
                                                    .solicitanteGrupoNombre
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: _vm.file.emisorContactoNombre,
                                      expression: "file.emisorContactoNombre"
                                    }
                                  ]
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("truncate")(
                                          _vm.file.emisorContactoNombre,
                                          30
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "vs-col",
                            {
                              attrs: {
                                "vs-lg": "3",
                                "vs-sm": "3",
                                "vs-xs": "12"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.file.solicitanteGrupoNombre) +
                                  " "
                              ),
                              _vm.file.solicitanteNombre
                                ? _c(
                                    "small",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value:
                                            "" + _vm.file.solicitanteNombre,
                                          expression:
                                            "`${file.solicitanteNombre}`"
                                        }
                                      ],
                                      staticClass: "d-block"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("truncate")(
                                              _vm.file.solicitanteNombre,
                                              20
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm.onPendingFiles
                            ? _c(
                                "vs-col",
                                {
                                  attrs: {
                                    "vs-lg": "3",
                                    "vs-sm": "3",
                                    "vs-xs": "12"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.file.derivadoPor) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          !_vm.onPendingFiles
                            ? _c(
                                "vs-col",
                                {
                                  attrs: {
                                    "vs-lg": "6",
                                    "vs-sm": "3",
                                    "vs-xs": "12"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.file.nombreDescriptivo) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.onPendingFiles
                            ? _c(
                                "vs-col",
                                {
                                  attrs: {
                                    "vs-lg": "3",
                                    "vs-sm": "3",
                                    "vs-xs": "12"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.file.nombreDescriptivo) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.screenSizeFull
                ? _c("RowLargeScreen", {
                    attrs: {
                      file: _vm.file,
                      "on-general-files": _vm.onGeneralFiles,
                      "on-pending-files": _vm.onPendingFiles
                    }
                  })
                : _vm._e(),
              !_vm.screenSizeFull
                ? _c("RowSmallScreen", {
                    attrs: {
                      file: _vm.file,
                      "on-general-files": _vm.onGeneralFiles,
                      "on-pending-files": _vm.onPendingFiles
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "vs-col",
            {
              attrs: {
                "vs-lg": "1",
                "vs-type": "flex",
                "vs-justify": "center",
                "vs-align": "center"
              }
            },
            [
              _vm._t(
                "actions",
                [
                  _c("FileOptions", {
                    ref: "file-options-" + _vm.file.febosId,
                    attrs: {
                      file: _vm.file,
                      "is-draft": _vm.isDraft,
                      "is-assigned": _vm.isAssigned,
                      "is-processed": _vm.isProcessed,
                      "is-cancelled": _vm.isCancelled,
                      "is-archivable": _vm.isArchivable,
                      "is-numbered": _vm.isNumbered,
                      "is-on-control": _vm.isOnControl,
                      "watch-process-file": _vm.watchProcessFile,
                      "is-responsible": _vm.isResponsible,
                      "on-pending-files": _vm.onPendingFiles,
                      "on-general-files": _vm.onGeneralFiles,
                      "on-pre-salida": _vm.onPreSalida,
                      "on-entered-files": _vm.onEnteredFiles,
                      "on-incomplete-files": _vm.canCompleteData,
                      "is-intern-file": _vm.isInternFile,
                      "can-assign-me-file": _vm.canAssignMeFile,
                      "can-process": _vm.canProcess,
                      "can-process-answer": _vm.canProcessAnswer,
                      "can-cancel": _vm.canCancel,
                      "can-cancel-admin": _vm.canCancelAdmin,
                      "can-send-to-flow": _vm.canSendToFlow,
                      "select-file": _vm.selectFile,
                      "is-response": _vm.isResponse,
                      "can-edit-file": _vm.canEditFile,
                      "can-edit-file-wizard": _vm.canEditFileWizard,
                      "can-send-doc-digital": _vm.canSendDocDigital,
                      "can-respond": _vm.canRespond,
                      "can-recover": _vm.canRecover
                    }
                  })
                ],
                { file: _vm.file }
              )
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }